import React from 'react';
import TermsAndConditions from '../components/Terms-Policy-Refund/TANDC';
import CenteredTitleSection from '../components/Terms-Policy-Refund/CenteredTitleSection';

const Terms = () => {
  return (
    <>
    <CenteredTitleSection
        title="Montessori Teacher Training Course"
        subtitle="Last Updated: 27/12/23"
      />
      <TermsAndConditions />
    </>
  );
};

export default Terms;
